module.exports = __webpack_public_path__ + "static/media/step-indicator-1.38dfcfc0.svg";